import image1 from "../assets/7.jpg";
import image2 from "../assets/9.jpg";
import image3 from "../assets/1.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "I made the right choice by choosing the Fitclub and by choosing the right plan and program I already achieved my ideal body!",
    name: 'ROHIT SINGH',
    status : 'ENTREPRENEUR'
  },
  {
    image: image2,
    review: 'Training with Coach at Fit Club has been transformative. Their expertise and support have propelled me towards my goals like never before ',
    name: 'BHOMIK KANDPAL',
    status: 'COACH'
  },
  {
    image : image3,
    review:' Fit Club is simply fantastic! The staff is supportive, the equipment is top-notch, and the atmosphere is always positive. Highly recommend!',
    name: 'NARENDRA SINGH BISHT',
    status: "CUSTOMER"
  }
];
